import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastFileDate'
})
export class LastFileDatePipe implements PipeTransform {

  transform(documents: any[]): unknown {
    if(!documents || !documents.length) {
      return '';
    }

    return null;
  }
}
